module.exports = __webpack_public_path__ + "img/8e90af4eda84d0b8728703821e8963f2.e681d81c.png";